import initialRecommendationDecisionCompleted from "./editors";
import initialDecisionsEditors from "./initial-decisions-editors";
import sectionCategory from "./sectionCategory";
import timeNone from './time-none';

export default [...timeNone, ...initialRecommendationDecisionCompleted, ...initialDecisionsEditors, ...sectionCategory];